angular.module('app.shared.userFeed.userFeedSortService', [])
  .factory('app.shared.userFeed.userFeedSortService', [
    function () {
      "use strict";

      let sorter;
      sorter = {
        options: {
          date_default_asc: {
            label: 'Date default sort (oldest - newest)',
            belongs_to: ['all']
          },
          date_default_desc: {
            label: 'Date default sort (newest - oldest)',
            belongs_to: ['all']
          },
          likes_desc: {
            label: 'Likes (most - least)',
            belongs_to: ['clip']
          },
          likes_asc: {
            label: 'Likes (least - most)',
            belongs_to: ['clip']
          },
          views_desc: {
            label: 'Views (most - least)',
            belongs_to: ['clip']
          },
          views_asc: {
            label: 'Views (least - most)',
            belongs_to: ['clip']
          },
          date_game_added_asc: {
            label: 'Date game added (newest - oldest)',
            belongs_to: ['favorite-game']
          },
          date_game_added_desc: {
            label: 'Date game added (oldest - newest)',
            belongs_to: ['favorite-game']
          }
        },
        default_option: 'date_default_desc',
        option_set_allowed: function (option, option_set) {
          if (!(option && option.belongs_to)) {
            option = sorter.options[option];
          }
          return option && (option.belongs_to.indexOf('all') !== -1 || option.belongs_to.indexOf(option_set) !== -1);
        },
        sort: function (feed, option_name, option_set) {
          if (feed) {
            let option;
            feed = angular.copy(feed);
            if (!option_name) {
              option = sorter.default_option;
            } else {
              option = sorter.options[option_name];
            }
            if (Array.isArray(feed) && option && sorter.option_set_allowed(option, option_set)) {
              feed.sort(function (a, b) {
                switch (option_name) {
                  case 'date_default_asc':
                    return compare(a.sort_date, b.sort_date);
                  case 'date_default_desc':
                    return compare(b.sort_date, a.sort_date);
                  case 'likes_asc':
                    return compare(a.likes, b.likes, 'number');
                  case 'likes_desc':
                    return compare(b.likes, a.likes, 'number');
                  case 'views_asc':
                    return compare(a.watch_count, b.watch_count, 'number');
                  case 'views_desc':
                    return compare(b.watch_count, a.watch_count, 'number');
                  case 'date_game_added_asc':
                    return compare(a.dtegametimefixed, b.dtegametimefixed);
                  case 'date_game_added_desc':
                    return compare(b.dtegametimefixed, a.dtegametimefixed);
                }
              });
            }
          }
          return feed;
        }
      };
      return sorter;
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/userFeed/userFeedSortService.js